import React from 'react';
import { IconCirclePlus } from '@tabler/icons-react';
import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { DashboardHeader } from '../../components/common';
import StandInFormModal from '../../components/stand-in-management/StandInFormModal';
import StandInTable from '../../components/stand-in-management/StandInTable';

function StandInHomePage() {
    const [addStandInModalOpened, standInModalHandlers] = useDisclosure(false);

    return (
        <div className="relative">
            <DashboardHeader
                title="Stand-In Management"
                hasBreadcrumb={false}
                hasDate
                isLoading={false}
                rightComponent={
                    <Button
                        fullWidth={false}
                        rightSection={<IconCirclePlus size={20} />}
                        onClick={standInModalHandlers.open}
                        size="md"
                    >
                        Add Stand-In
                    </Button>
                }
            />
            <div className="px-11 flex flex-col flex-1 gap-5">
                <StandInTable />
            </div>
            <StandInFormModal
                onClose={standInModalHandlers.close}
                opened={addStandInModalOpened}
            />
        </div>
    );
}

export default StandInHomePage;
